import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
@Pipe({
  name: 'calendarErrorMapping',
})
export class CalendarErrorMappingPipe implements PipeTransform {
  transform(
    errors: ValidationErrors,
    errorMessageMapping: Map<string, string>,
    showRequired: boolean = false
  ): string {
    let result = '';
    if (!errors) {
      return result;
    } else {
      const keys: string[] = Object.keys(errors);
      if (errors && errorMessageMapping && Array.isArray(keys)) {
        // 僅顯示第一筆錯誤訊息
        result =
          errorMessageMapping.get(
            keys[0] === 'required' ?
             showRequired && keys?.length === 1 ?
              keys[0] : keys[1]
              : keys[0]
          ) ?? '';
      }
      return result;
    }
  }
}
